import { QueryClient } from "@tanstack/react-query";
import { ACCOUNT, SITE } from "../constants/QueryKeys";

export const queryClient = new QueryClient();

/** Server-backed data that never goes stale on its own; seams write the cache. */
export const STATIC_QUERY_DEFAULTS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: Infinity,
  retry: false,
};

/** Lifetime cache: replaces a singleton store; GC would strand later seam writes. */
export const STORE_CACHE_DEFAULTS = {
  ...STATIC_QUERY_DEFAULTS,
  gcTime: Infinity,
};

/** Store cache that is only ever fed imperatively (no queryFn fetching on mount). */
export const IMPERATIVE_CACHE_DEFAULTS = {
  ...STORE_CACHE_DEFAULTS,
  enabled: false,
  refetchOnMount: false,
};

/**
 * Evicts session caches when the login screen mounts, keeping ACCOUNT (login
 * error state) and SITE (so a 401 -> re-login restores the last-open design).
 */
export const resetCachesForLogin = () => {
  queryClient.removeQueries({
    predicate: (query) => query.queryKey[0] !== ACCOUNT && query.queryKey[0] !== SITE,
  });
};
